import { useState, useEffect } from 'react';
import type { Ticket } from '../types';
import { slaStatus } from '../utils/helpers';

interface Props { ticket: Ticket; compact?: boolean; }

export default function SLAIndicator({ ticket, compact }: Props) {
  const [, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick(n => n + 1), 60_000);
    return () => clearInterval(id);
  }, []);

  const s = slaStatus(ticket);
  if (!s) return null;

  const pct = Math.min(100, Math.max(0, s.pct));
  const barColor =
    s.status === 'Overdue'  ? '#B91C1C' :
    s.status === 'Critical' ? '#F97316' :
    s.status === 'Warning'  ? '#EAB308' : '#1A7A3C';

  if (compact) {
    return (
      <span
        className="text-[10px] font-semibold px-1.5 py-0.5 rounded-full"
        style={{ background: barColor + '22', color: barColor }}
      >
        {s.isOverdue ? 'SLA Breached' : `${s.remaining}h left`}
      </span>
    );
  }

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center justify-between text-xs">
        <span className="font-medium" style={{ color: barColor }}>{s.status}</span>
        <span className="text-gray-400">
          {s.isOverdue ? `${Math.abs(s.remaining)}h over` : `${s.remaining}h left`}
        </span>
      </div>
      <div className="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-1000"
          style={{ width: `${pct}%`, background: barColor }}
        />
      </div>
    </div>
  );
}
